import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '最新内容', href: '/category/latest' },
      { label: '独家资源', href: '/category/exclusive' },
      { label: '精品推荐', href: '/category/featured' },
      { label: '热门排行', href: '/category/popular' },
      { label: '会员专区', href: '/category/members' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '发展历程', href: '/about' },
      { label: '加入我们', href: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/about' },
      { label: '联系我们', href: '/about' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">蜜桃传媒</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专注优质内容创作与传播的媒体平台，汇聚海量精品资源，为用户提供极致娱乐体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="mailto:contact@mitaomedia.com" className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 蜜桃传媒文化传播有限公司 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            京ICP备XXXXXXXX号 | 京公网安备XXXXXXXXXX号
          </p>
        </div>
      </div>
    </footer>
  );
}